"use strict";
/* Copyright (c) 2022 Xperi. All Rights Reserved. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QoE = void 0;
var AnalyticsConstants_1 = require("./AnalyticsConstants");
var EventQueue_1 = require("./eventqueue/EventQueue");
var EventQueueHandler_1 = require("./eventqueue/EventQueueHandler");
var QoELogger_1 = require("./loggers/QoELogger");
var Payload_1 = require("./sendables/Payload");
var NoTransport_1 = require("./transports/NoTransport");
var QoE = /** @class */ (function () {
    function QoE() {
    }
    QoE.logQoEEvent = function (finalPayload) {
        if (QoE.isSynchronised) {
            QoE.eventQueue.add(finalPayload);
            QoE.eventQueuehandler.startDequeueing();
        }
        else
            QoE.logger.log(finalPayload);
    };
    QoE.disabled = function () {
        this.logger.isDisabled = true;
        this.logger.setTransport(new NoTransport_1.NoTransport());
    };
    QoE.getInstance = function () {
        return QoE.logger;
    };
    QoE.setGlobals = function (params) {
        QoE.globals = params;
    };
    QoE.synchronised = function (value) {
        QoE.isSynchronised = value;
    };
    /**
     * The QoE schema is based on the Playback Client Raw Events for Measuring Quality of Experience
     * (Link: https://confluence.corp.xperi.com/pages/viewpage.action?spaceKey=TVSOI&title=Playback+Client+Raw+Events+for+Measuring+Quality+of+Experience).
     * Below are the methods parts of QoE Schema.
     */
    QoE.logApplicationStart = function (data) {
        if (!data)
            data = new Payload_1.Payload();
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.APPLICATION_START);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var payload = data.merge(QoE.globals);
        QoE.logQoEEvent(payload);
    };
    QoE.logFirstFrame = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.FIRST_FRAME);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var payload = data.merge(QoE.globals);
        QoE.logQoEEvent(payload);
    };
    QoE.logMediaHealth = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.MEDIA_HEALTH);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var payload = data.merge(QoE.globals);
        QoE.logQoEEvent(payload);
    };
    QoE.logSessionCreated = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.SESSION_CREATED);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var payload = data.merge(QoE.globals);
        QoE.logQoEEvent(payload);
    };
    QoE.logStreamingEnd = function (data) {
        if (QoE.isStreamingStartSent) {
            QoE.isStreamingStartSent = false;
            data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.STREAMING_END);
            data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
            var payload = data.merge(QoE.globals);
            QoE.logQoEEvent(payload);
        }
    };
    QoE.logStreamingStart = function (data) {
        QoE.isStreamingStartSent = true;
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.STREAMING_START);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var payload = data.merge(QoE.globals);
        QoE.logQoEEvent(payload);
    };
    QoE.logWatchContentEnd = function (data) {
        if (QoE.isWatchStartSent) {
            QoE.isWatchStartSent = false;
            data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.WATCH_CONTENT_END);
            data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
            var payload = data.merge(QoE.globals);
            QoE.logQoEEvent(payload);
        }
    };
    QoE.logWatchContentStart = function (data) {
        QoE.isWatchStartSent = true;
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.WATCH_CONTENT_START);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var payload = data.merge(QoE.globals);
        QoE.logQoEEvent(payload);
    };
    QoE.logVideoPlayerOpenStream = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.VIDEO_PLAYER_OPEN_STREAM);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var payload = data.merge(QoE.globals);
        QoE.logQoEEvent(payload);
    };
    QoE.setEventQueueSize = function (size) {
        QoE.eventQueue.setSize(size);
    };
    QoE.noConsole = function () {
        this.logger.noConsole = true;
    };
    QoE.logger = new QoELogger_1.QoELogger();
    QoE.eventQueue = new EventQueue_1.EventQueue();
    QoE.isSynchronised = true;
    QoE.isWatchStartSent = false;
    QoE.isStreamingStartSent = false;
    QoE.eventQueuehandler = new EventQueueHandler_1.EventQueueHandler(QoE.logger, QoE.eventQueue);
    return QoE;
}());
exports.QoE = QoE;
